import {
  BRAZIL_CNTRY_CODE,
  CANADA_CNTRY_CODE,
  EN_US_LOCALE,
  ES_ES_LOCALE,
  FR_CA_LOCALE,
  PT_BR_LOCALE,
  SPANISH_COUNTRIES_CODE,
} from "./constants";

export const formatDate = (date) => {
  if (!date) return "";
  const dateObj = new Date(date);
  let dayValue = dateObj.getUTCDate().toString().padStart(2, "0");
  let monthValue = (dateObj.getUTCMonth() + 1).toString().padStart(2, "0");
  let yearValue = dateObj.getUTCFullYear();
  return dayValue + "/" + monthValue + "/" + yearValue;
};

export const displayUSformattedDate = (date) => {
  if (!date) return "NA";

  const dateObj = new Date(date);
  let dayValue = dateObj.getUTCDate().toString().padStart(2, "0");
  let monthValue = (dateObj.getUTCMonth() + 1).toString().padStart(2, "0");
  let yearValue = dateObj.getUTCFullYear();
  return monthValue + "/" + dayValue + "/" + yearValue;
};

export const cnvrtStringDateToNormalDateObj = (stringDate) => {
  try {
    const dateParts = stringDate.split("/");
    const dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
    return dateObject;
  } catch (error) {
    return new Date();
  }
};

export const getLocale = (userDetails) => {
  if (userDetails) {
    if (userDetails.locale) {
      return userDetails.locale;
    }
    if (userDetails.countryCode) {
      if (userDetails.countryCode === BRAZIL_CNTRY_CODE) {
        return PT_BR_LOCALE;
      } else if (userDetails.countryCode === CANADA_CNTRY_CODE) {
        return FR_CA_LOCALE;
      } else if (SPANISH_COUNTRIES_CODE.includes(userDetails.countryCode)) {
        return ES_ES_LOCALE;
      }
    }
  }
  return EN_US_LOCALE;
};

export const avgSprdMrgPct = (avgSprdPct) => {
  let arrAvgSprdPct = [];
  let avgSprdPctValue;
  if (avgSprdPct === "-_30" || avgSprdPct === "-_15") {
    arrAvgSprdPct.push(1);
    avgSprdPctValue = parseInt(avgSprdPct.substr(2, 4));
    arrAvgSprdPct.push(avgSprdPctValue);
  } else if (avgSprdPct === "30_+") {
    arrAvgSprdPct.push(2);
    avgSprdPctValue = parseInt(avgSprdPct.substr(0, 2));
    arrAvgSprdPct.push(avgSprdPctValue);
  }
  return arrAvgSprdPct;
};
